(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!customElements.get('marais-announcement-timer')) {
    customElements.define('marais-announcement-timer', class extends HTMLElement {
      connectedCallback() {
        this.deadline = Date.parse(this.dataset.end);
        if (!Number.isFinite(this.deadline)) { this.hidden = true; return; }
        this.values = Array.from(this.querySelectorAll('[data-value]'));
        this.visibilityHandler = () => {
          clearInterval(this.interval);
          if (!document.hidden && this.tick()) this.interval = setInterval(() => this.tick(), 1000);
        };
        document.addEventListener('visibilitychange', this.visibilityHandler);
        this.visibilityHandler();
      }
      disconnectedCallback() {
        clearInterval(this.interval);
        document.removeEventListener('visibilitychange', this.visibilityHandler);
      }
      tick() {
        const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        if (!remaining) {
          clearInterval(this.interval);
          const section = this.closest('.shopify-section');
          if (section) section.hidden = true;
          document.documentElement.style.setProperty('--announcement-bar-height', '0px');
          return false;
        }
        const units = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60 };
        this.values.forEach(node => {
          const value = String(units[node.dataset.value]).padStart(2, '0');
          if (node.textContent !== value) node.textContent = value;
        });
        const minute = Math.floor(remaining / 60);
        if (this.lastMinute !== minute) {
          this.setAttribute('aria-label', `${this.dataset.label}: ${this.values.slice(0, 3).map(node => `${node.textContent} ${node.nextElementSibling.textContent}`).join(', ')}`);
          this.lastMinute = minute;
        }
        return true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const syncFooterMenus = () => {
      document.querySelectorAll('.shopify-section--footer .footer__menu-details').forEach((menu) => {
        if (window.innerWidth < 750) menu.removeAttribute('open');
        else menu.setAttribute('open', '');
      });
    };
    syncFooterMenus();
    window.addEventListener('resize', syncFooterMenus, { passive: true });
    document.addEventListener('shopify:section:load', syncFooterMenus);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const initialized = new WeakSet();
    const initInfiniteCollection = (loader) => {
      if (!loader || initialized.has(loader)) return;
      initialized.add(loader);
      const nextLink = loader.querySelector('[data-collection-next]');
      if (!nextLink) return;
      let loading = false;
      let observer;

      const loadNextPage = async () => {
        if (loading || !nextLink.href) return;
        loading = true;
        nextLink.classList.add('is-loading');
        nextLink.textContent = 'CARGANDO';
        try {
          const response = await fetch(nextLink.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error('collection-load-failed');
          const documentNext = new DOMParser().parseFromString(await response.text(), 'text/html');
          const sectionId = loader.dataset.sectionId;
          const currentList = loader.closest('.shopify-section')?.querySelector('.product-list');
          const incomingList = documentNext.querySelector('#shopify-section-' + sectionId + ' .product-list');
          const incomingNext = documentNext.querySelector('#shopify-section-' + sectionId + ' [data-collection-next]');
          if (!currentList || !incomingList) throw new Error('collection-response-invalid');

          [...incomingList.children].forEach((item) => {
            if (!item.classList.contains('product-list__promo')) currentList.appendChild(item);
          });

          const incomingNextHref = incomingNext?.getAttribute('href');
          if (incomingNextHref) {
            nextLink.href = new URL(incomingNextHref, window.location.href).href;
            nextLink.classList.remove('is-loading');
            nextLink.textContent = 'CARGAR MÁS';
            loading = false;
            observer?.observe(nextLink);
          } else {
            loader.remove();
          }
        } catch (error) {
          nextLink.classList.remove('is-loading');
          nextLink.textContent = 'REINTENTAR';
          loading = false;
          observer?.observe(nextLink);
        }
      };

      nextLink.addEventListener('click', (event) => {
        event.preventDefault();
        observer?.unobserve(nextLink);
        loadNextPage();
      });

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.unobserve(nextLink);
          loadNextPage();
        }, { rootMargin: '700px 0px' });
        observer.observe(nextLink);
      }
    };

    const initAll = (scope = document) => scope.querySelectorAll('[data-collection-infinite]').forEach(initInfiniteCollection);
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    new MutationObserver(() => initAll()).observe(document.documentElement, { childList:true, subtree:true });
  })();

  (() => {
    if (window.__maraisCollectionSizesLoaded) return;
    window.__maraisCollectionSizesLoaded = true;
    const touchLayout = () => matchMedia('(max-width: 699px), (hover: none), (pointer: coarse)').matches;
    const photoFor = picker => picker.closest('product-card')?.querySelector('.product-card__figure > a');
    const closeSizes = except => document.querySelectorAll('[data-sale-size-picker].is-open').forEach(picker => {
      if (picker === except) return;
      picker.classList.remove('is-open');
      photoFor(picker)?.setAttribute('aria-expanded', 'false');
    });
    document.addEventListener('click', event => {
      const photo = event.target.closest('.product-card__figure > a');
      const picker = photo?.closest('product-card')?.querySelector('[data-sale-size-picker]');
      if (touchLayout() && photo && picker && event.detail > 0 && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        if (!picker.classList.contains('is-open')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          closeSizes(picker);
          picker.classList.add('is-open');
          photo.setAttribute('aria-expanded', 'true');
          const options = picker.querySelector('.product-card__sale-size-options');
          if (options?.id) photo.setAttribute('aria-controls', options.id);
          return;
        }
        closeSizes();
        return;
      }
      if (!event.target.closest('[data-sale-size-picker]')) closeSizes();
    }, true);
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') closeSizes();
    });
    window.addEventListener('resize', () => { if (!touchLayout()) closeSizes(); }, { passive: true });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marais-collection-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clean = (value) => (value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();

    const appendBreadcrumb = (section, heading, universe, category, currentLabel) => {
      section.querySelectorAll('.marais-collection-intro__links, .marais-collection-intro__breadcrumb').forEach((navigation) => navigation.remove());

      const breadcrumb = document.createElement('nav');
      breadcrumb.className = 'marais-collection-intro__breadcrumb';
      breadcrumb.setAttribute('aria-label', 'Ruta de navegación');

      const appendLink = (label, href) => {
        const link = document.createElement('a');
        link.href = href;
        link.textContent = label;
        breadcrumb.append(link);
      };
      const appendSeparator = () => {
        const separator = document.createElement('span');
        separator.setAttribute('aria-hidden', 'true');
        separator.textContent = '/';
        breadcrumb.append(separator);
      };

      appendLink(universe.label, universe.url);
      appendSeparator();
      if (category) {
        appendLink(category.label, category.url);
        appendSeparator();
      }

      const current = document.createElement('span');
      current.setAttribute('aria-current', 'page');
      current.textContent = currentLabel;
      breadcrumb.append(current);
      heading.before(breadcrumb);
    };

    const getContext = () => {
      const path = window.location.pathname.replace(/\/$/, '');
      const handle = path.split('/').filter(Boolean).pop() || '';
      const universe = handle.startsWith('hombre-') ? { label: 'Hombre', url: '/collections/hombre-2026', key: 'hombre' }
        : handle.startsWith('mujer-') ? { label: 'Mujer', url: '/collections/mujer-2026', key: 'mujer' }
        : handle.startsWith('ninos-') ? { label: 'Niños', url: '/collections/ninos-2026', key: 'ninos' }
        : null;
      const category = handle.includes('-ropa-') ? { label: 'Ropa', url: path, key: 'ropa' }
        : handle.includes('-calzado-') ? { label: 'Calzado', url: path, key: 'calzado' }
        : null;
      return { path, handle, universe, category };
    };

    const getLeafLabel = (types, context) => {
      const includes = (term) => types.some((type) => type.includes(term));

      if (context.category?.key === 'ropa') {
        if (context.universe?.key === 'ninos' && includes('poleron')) return 'Sweaters';
        if (includes('chaqueta')) return 'Chaquetas & Parkas';
        if (includes('pantalon') || includes('falda') || includes('short') || types.includes('pant')) {
          return context.universe?.key === 'mujer' ? 'Pantalones & Faldas' : 'Pantalones & Shorts';
        }
        if (includes('chaleco') || includes('poleron')) return 'Chalecos & Polerones';
        if (includes('polera') || includes('camisa')) return 'Poleras & Camisas';
      }

      if (context.category?.key === 'calzado') {
        const hasSandalias = includes('sandalia');
        const hasSuecos = includes('sueco');
        if (hasSandalias && hasSuecos) return 'Sandalias & Suecos';
        if (hasSandalias) return 'Sandalias';
        if (hasSuecos) return 'Suecos';
        if (includes('zapatilla') || includes('sneaker')) return 'Zapatillas';
      }

      const fallback = types[0] || '';
      return fallback ? fallback.charAt(0).toUpperCase() + fallback.slice(1) : '';
    };

    const applyCollectionView = (section) => {
      if (!section || section.dataset.maraisContextReady === window.location.href) return;

      const heading = section.querySelector('h1');
      if (!heading) return;

      const params = new URLSearchParams(window.location.search);
      const productTypes = params.getAll('filter.p.product_type').map(clean).filter(Boolean);
      const context = getContext();

      if (productTypes.length && context.universe && context.category) {
        const leafLabel = getLeafLabel(productTypes, context);
        if (!leafLabel) return;

        heading.textContent = leafLabel;
        section.querySelectorAll('.marais-collection-intro__description').forEach((description) => description.remove());
        appendBreadcrumb(section, heading, context.universe, context.category, leafLabel);
        section.dataset.leafView = 'true';
        section.dataset.maraisContextReady = window.location.href;
        return;
      }

      const rawVendor = params.get('filter.p.vendor');
      if (rawVendor && context.universe && !context.category) {
        const vendorNames = {
          'VEJA': 'Veja',
          'Cacatoes': 'Cacatoès',
          'HEYDUDE': 'Hey Dude',
          'SCOTCH & SODA': 'Scotch & Soda',
          'Carhartt WIP': 'Carhartt WIP'
        };
        const vendor = vendorNames[rawVendor] || rawVendor;
        const universeLabel = context.universe.key === 'ninos' ? 'Kids' : context.universe.label;
        heading.textContent = universeLabel + ' ' + vendor;
        section.querySelectorAll('.marais-collection-intro__description, .marais-collection-intro__links, .marais-collection-intro__breadcrumb').forEach((element) => element.remove());
        section.dataset.leafView = 'true';
        section.dataset.maraisContextReady = window.location.href;
      }
    };

    const applyAllCollectionViews = (root = document) => {
      root.querySelectorAll?.('.marais-collection-intro').forEach(applyCollectionView);
      if (root.matches?.('.marais-collection-intro')) applyCollectionView(root);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => applyAllCollectionViews(), { once: true });
    } else {
      applyAllCollectionViews();
    }
    document.addEventListener('shopify:section:load', (event) => applyAllCollectionViews(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marais-editorial-discovery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marais-discovery-slider')) {
    customElements.define('marais-discovery-slider', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('.mm-discovery__grid');
        if (!track) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const cards = Array.from(track.children);
        const alignTitles = () => {
          if (!this.matches('.mm-discovery--grid, .mm-discovery--strip')) return;
          const rows = [];
          cards.forEach(card => {
            const title = card.querySelector('h3');
            if (title) title.style.removeProperty('min-height');
          });
          cards.forEach(card => {
            const title = card.querySelector('h3');
            if (!title) return;
            const top = card.getBoundingClientRect().top;
            let row = rows.find(item => Math.abs(item.top - top) < 2);
            if (!row) {
              row = { top, titles: [], height: 0 };
              rows.push(row);
            }
            row.titles.push(title);
            row.height = Math.max(row.height, title.getBoundingClientRect().height);
          });
          rows.forEach(row => {
            row.titles.forEach(title => { title.style.minHeight = row.height + 'px'; });
          });
        };
        const scheduleAlignment = () => {
          cancelAnimationFrame(this.alignmentFrame);
          this.alignmentFrame = requestAnimationFrame(alignTitles);
        };
        this.alignmentObserver = new ResizeObserver(scheduleAlignment);
        this.alignmentObserver.observe(track);
        window.addEventListener('resize', scheduleAlignment, { passive: true, signal });
        document.fonts.ready.then(() => { if (this.isConnected) scheduleAlignment(); });
        document.fonts.addEventListener('loadingdone', scheduleAlignment, { signal });
        scheduleAlignment();

        const dots = this.querySelector('.mm-discovery__dots');
        if (!dots || !cards.length) return;
        const buttons = Array.from(dots.querySelectorAll('button'));
        const update = () => {
          const max = Math.max(0, track.scrollWidth - track.clientWidth);
          dots.hidden = max < 2;
          const start = cards[0].offsetLeft;
          let current = 0;
          cards.forEach((card, index) => {
            if (Math.abs(track.scrollLeft - Math.min(max, card.offsetLeft - start)) < Math.abs(track.scrollLeft - Math.min(max, cards[current].offsetLeft - start))) current = index;
          });
          buttons.forEach((button, index) => button.setAttribute('aria-current', index === current ? 'true' : 'false'));
        };
        const go = index => {
          const max = Math.max(0, track.scrollWidth - track.clientWidth);
          track.scrollTo({ left: Math.min(max, cards[index].offsetLeft - cards[0].offsetLeft), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        dots.addEventListener('click', event => {
          const button = event.target.closest('[data-discovery-dot]');
          if (button) go(Number(button.dataset.discoveryDot));
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const index = cards.findIndex(card => card.contains(event.target));
          if (index !== -1) go(index);
        }, { signal });
        track.addEventListener('scroll', update, { passive: true, signal });
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.alignmentObserver?.disconnect();
        cancelAnimationFrame(this.alignmentFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marais-editorial-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeHeader = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const desktopMedia = window.matchMedia('(min-width: 990px)');
      const triggers = [...root.querySelectorAll('[data-marais-mega-trigger]')];
      const panels = [...root.querySelectorAll('[data-marais-mega-panel]')];
      const dialog = root.querySelector('[data-marais-mobile-dialog]');
      const openButton = root.querySelector('[data-marais-mobile-open]');
      const closeButton = root.querySelector('[data-marais-mobile-close]');
      const collapseAt = Number(root.dataset.collapseAt || 48);
      const isInnerPage = root.dataset.innerPage === 'true' || root.classList.contains('is-inner-page');
      let closeTimer;
      let lastFocusedElement;
      // MARAIS HEADER · STABLE MEGA MENU HOVER 2026-08-10

      // MARAIS HEADER · PERMANENT INNER COMPACT LOCK 2026-08-10
      const updateCondensedState = () => {
        root.classList.toggle('is-condensed', isInnerPage || window.scrollY > collapseAt);
      };

      const closeMegaMenus = () => {
        window.clearTimeout(closeTimer);
        root.classList.remove('is-menu-open');
        triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        panels.forEach((panel) => {
          panel.classList.remove('is-open');
          panel.setAttribute('aria-hidden', 'true');
        });
      };

      const openMegaMenu = (index) => {
        if (!desktopMedia.matches) return;
        window.clearTimeout(closeTimer);
        root.classList.add('is-menu-open');
        const syncMegaGeometry = () => {
          const surface = root.querySelector('.marais-ed__surface');
          const bottom = surface ? surface.getBoundingClientRect().bottom : root.getBoundingClientRect().bottom;
          root.style.setProperty('--marais-mega-top', Math.max(0, bottom) + 'px');
        };
        syncMegaGeometry();
        window.requestAnimationFrame(syncMegaGeometry);
        window.setTimeout(syncMegaGeometry, 580);
        triggers.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', trigger.dataset.maraisMegaTrigger === index ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          const isOpen = panel.dataset.maraisMegaPanel === index;
          panel.classList.toggle('is-open', isOpen);
          panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        });
      };

      triggers.forEach((trigger) => {
        const index = trigger.dataset.maraisMegaTrigger;
        trigger.addEventListener('mouseenter', () => openMegaMenu(index));
        trigger.addEventListener('focus', () => openMegaMenu(index));
        trigger.addEventListener('click', () => {
          const isOpen = trigger.getAttribute('aria-expanded') === 'true';
          if (!isOpen) openMegaMenu(index);
        });
      });

      root.addEventListener('mouseenter', () => window.clearTimeout(closeTimer));
      root.addEventListener('mouseleave', (event) => {
        if (!desktopMedia.matches || root.contains(event.relatedTarget)) return;
        closeTimer = window.setTimeout(closeMegaMenus, 360);
      });

      panels.forEach((panel) => {
        panel.addEventListener('mouseenter', () => window.clearTimeout(closeTimer));
        panel.addEventListener('mouseleave', (event) => {
          if (root.contains(event.relatedTarget)) return;
          closeTimer = window.setTimeout(closeMegaMenus, 360);
        });
      });

      const openDialog = (event) => {
        event?.preventDefault();
        event?.stopPropagation();
        if (!dialog || dialog.open) return;
        lastFocusedElement = document.activeElement;
        dialog.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));

        try {
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        } catch (error) {
          dialog.setAttribute('open', '');
        }

        dialog.focus({ preventScroll: true });
        openButton?.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
      };

      openButton?.addEventListener('click', openDialog);

      const closeDialog = () => {
        if (!dialog?.open) return;
        try {
          if (typeof dialog.close === 'function') dialog.close();
          else dialog.removeAttribute('open');
        } catch (error) {
          dialog.removeAttribute('open');
        }
        openButton?.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        lastFocusedElement?.focus();
      };

      closeButton?.addEventListener('click', closeDialog);
      dialog?.addEventListener('close', () => {
        openButton?.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
      });
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });
      dialog?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeDialog));

      dialog?.querySelectorAll('.marais-ed__mobile-details').forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          dialog.querySelectorAll('.marais-ed__mobile-details').forEach((other) => {
            if (other !== details) other.removeAttribute('open');
          });
        });
      });

      dialog?.querySelectorAll('.marais-ed__mobile-group').forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          details.closest('.marais-ed__mobile-submenu')?.querySelectorAll('.marais-ed__mobile-group').forEach((other) => {
            if (other !== details) other.removeAttribute('open');
          });
        });
      });

      document.addEventListener('click', (event) => {
        if (desktopMedia.matches && !root.contains(event.target)) closeMegaMenus();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeMegaMenus();
      });
      desktopMedia.addEventListener?.('change', () => {
        closeMegaMenus();
        closeDialog();
      });
      const handleScroll = () => {
        updateCondensedState();
        root.style.setProperty('--marais-mega-top', Math.max(0, root.getBoundingClientRect().bottom) + 'px');
      };
      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll();
    };

    document.querySelectorAll('[data-marais-editorial-header]').forEach(initializeHeader);
    document.addEventListener('shopify:section:load', (event) => initializeHeader(event.target.querySelector('[data-marais-editorial-header]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marais-editorial-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeHome = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const items = root.querySelectorAll('[data-marais-reveal]');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }
      root.classList.add('marais-motion-ready');

      root.querySelectorAll('[data-marais-slider]').forEach((slider) => {
        const slides = [...slider.querySelectorAll('[data-marais-slide]')];
        const dots = [...slider.querySelectorAll('[data-marais-dot]')];
        if (slides.length < 2) return;
        let activeIndex = 0;
        let timer;
        let touchStart = 0;
        const interval = Number(slider.dataset.interval) || 6000;
        const showSlide = (nextIndex) => {
          activeIndex = (nextIndex + slides.length) % slides.length;
          slides.forEach((slide, index) => {
            const active = index === activeIndex;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          });
          dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
        };
        const stop = () => window.clearInterval(timer);
        const play = () => {
          stop();
          if (slider.dataset.autoplay !== 'true') return;
          timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
        };
        slider.querySelector('[data-marais-prev]')?.addEventListener('click', () => {
          showSlide(activeIndex - 1);
          play();
        });
        slider.querySelector('[data-marais-next]')?.addEventListener('click', () => {
          showSlide(activeIndex + 1);
          play();
        });
        dots.forEach((dot) => dot.addEventListener('click', () => {
          showSlide(Number(dot.dataset.maraisDot));
          play();
        }));
        slider.addEventListener('mouseenter', stop);
        slider.addEventListener('mouseleave', play);
        slider.addEventListener('touchstart', (event) => {
          touchStart = event.touches[0].clientX;
          stop();
        }, { passive: true });
        slider.addEventListener('touchend', (event) => {
          const distance = event.changedTouches[0].clientX - touchStart;
          if (Math.abs(distance) > 45) showSlide(activeIndex + (distance < 0 ? 1 : -1));
          play();
        }, { passive: true });
        slider.addEventListener('shopify:block:select', (event) => {
          const selectedSlide = event.target.closest('[data-marais-slide]');
          if (selectedSlide) showSlide(Number(selectedSlide.dataset.index));
          stop();
        });
        play();
      });

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: .12, rootMargin: '0px 0px -10% 0px' });
      items.forEach((item) => observer.observe(item));

      const hero = root.querySelector('.marais-home__hero');
      let frame;
      const updateHero = () => {
        frame = undefined;
        if (!hero) return;
        const rect = hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const shift = Math.max(-46, Math.min(46, rect.top * -.07));
        hero.style.setProperty('--mh-hero-shift', `${shift}px`);
      };
      const requestHeroUpdate = () => {
        if (frame) return;
        frame = requestAnimationFrame(updateHero);
      };
      updateHero();
      window.addEventListener('scroll', requestHeroUpdate, { passive: true });

      root.querySelectorAll('.marais-home__product-scroll').forEach((rail) => {
        let startX = 0;
        let startScroll = 0;
        let moved = false;
        rail.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          startX = event.clientX;
          startScroll = rail.scrollLeft;
          moved = false;
          rail.classList.add('is-dragging');
          rail.setPointerCapture(event.pointerId);
        });
        rail.addEventListener('pointermove', (event) => {
          if (!rail.classList.contains('is-dragging')) return;
          const distance = event.clientX - startX;
          moved = moved || Math.abs(distance) > 6;
          rail.scrollLeft = startScroll - distance;
        });
        const stopDrag = (event) => {
          if (!rail.classList.contains('is-dragging')) return;
          rail.classList.remove('is-dragging');
          if (rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
        };
        rail.addEventListener('pointerup', stopDrag);
        rail.addEventListener('pointercancel', stopDrag);
        rail.addEventListener('click', (event) => {
          if (!moved) return;
          event.preventDefault();
          moved = false;
        }, true);
      });
    };
    document.querySelectorAll('[data-marais-home]').forEach(initializeHome);
    document.addEventListener('shopify:section:load', (event) => initializeHome(event.target.querySelector('[data-marais-home]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marais-featured-brands"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.motionReady === 'true') return;
      const button = root.querySelector('[data-marais-brands-toggle]');
      if (!button) return;
      button.addEventListener('click', () => {
        const paused = root.dataset.paused !== 'true';
        root.dataset.paused = String(paused);
        button.setAttribute('aria-label', paused ? button.dataset.resumeLabel : button.dataset.pauseLabel);
      });
      button.hidden = false;
      root.dataset.motionReady = 'true';
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        root.dataset.inView = String(entry.isIntersecting);
      }));
      observer.observe(root);
      root.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    };
    document.querySelectorAll('[data-marais-brand-marquee]').forEach(initialize);
    document.addEventListener('shopify:section:load', event => initialize(event.target.querySelector('[data-marais-brand-marquee]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marais-featured-category-modular"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFeature = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('is-motion-ready');
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (!entry.isIntersecting) return; entry.target.classList.add('is-visible'); observer.unobserve(entry.target);
      }), { threshold: .12, rootMargin: '0px 0px -8% 0px' });
      root.querySelectorAll('[data-mm-feature-reveal]').forEach((item) => observer.observe(item));
      const update = () => {
        if (window.innerWidth < 990) { root.style.setProperty('--mm-feature-copy-shift', '0px'); return; }
        const rect = root.getBoundingClientRect();
        const progress = Math.min(Math.max((window.innerHeight - rect.top) / (window.innerHeight + rect.height), 0), 1);
        const travel = Number(root.dataset.copyTravel) || 0;
        root.style.setProperty('--mm-feature-copy-shift', `${Math.round(progress * travel)}px`);
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    };
    document.querySelectorAll('[data-mm-feature]').forEach(initFeature);
    document.addEventListener('shopify:section:load', (event) => initFeature(event.target.querySelector('[data-mm-feature]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marais-hero-modular"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHero = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const track = root.querySelector('[data-mm-hero-track]');
      const slides = [...root.querySelectorAll('[data-mm-hero-slide]')];
      const dots = [...root.querySelectorAll('[data-mm-hero-dot]')];
      if (slides.length < 2) return;
      let active = 0;
      let timer;
      const show = (index) => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
      };
      const play = () => {
        clearInterval(timer);
        if (root.dataset.autoplay !== 'true' || window.innerWidth < 990 || root.classList.contains('mm-hero--desktop-split')) return;
        timer = setInterval(() => show(active + 1), Number(root.dataset.interval) || 6000);
      };
      const updateCopyPosition = () => {
        if (window.innerWidth < 990) {
          root.style.setProperty('--mm-hero-copy-shift', '0px');
          return;
        }
        const rootTop = root.getBoundingClientRect().top + window.scrollY;
        const localScroll = Math.max(window.scrollY - rootTop, 0);
        const copy = root.querySelector('.mm-hero__content');
        if (!copy) return;
        const bottomSafeArea = 54;
        const maxTravel = Math.max(root.clientHeight - copy.offsetTop - copy.offsetHeight - bottomSafeArea, 0);
        const configuredTravel = Number(root.dataset.copyTravel) || maxTravel;
        const travel = Math.min(configuredTravel, maxTravel);
        const shift = Math.min(localScroll * 0.78, travel);
        root.style.setProperty('--mm-hero-copy-shift', `${Math.round(shift)}px`);
      };
      dots.forEach((dot) => dot.addEventListener('click', () => {
        const index = Number(dot.dataset.mmHeroDot);
        if (window.innerWidth < 990 && root.classList.contains('mm-hero--mobile-slider')) track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
        show(index);
        play();
      }));
      let scrollFrame;
      track.addEventListener('scroll', () => {
        if (window.innerWidth >= 990 || !root.classList.contains('mm-hero--mobile-slider')) return;
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => show(Math.round(track.scrollLeft / track.clientWidth)));
      }, { passive: true });
      root.addEventListener('mouseenter', () => clearInterval(timer));
      root.addEventListener('mouseleave', play);
      window.addEventListener('scroll', updateCopyPosition, { passive: true });
      window.addEventListener('resize', updateCopyPosition, { passive: true });
      updateCopyPosition();
      play();
    };
    document.querySelectorAll('[data-mm-hero]').forEach(initHero);
    document.addEventListener('shopify:section:load', (event) => initHero(event.target.querySelector('[data-mm-hero]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marais-product-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeProductEditorial = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const items = root.querySelectorAll('[data-marais-product-reveal]');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: .06, rootMargin: '0px 0px -6% 0px' });
      items.forEach((item) => observer.observe(item));
    };
    document.querySelectorAll('[data-marais-product-editorial]').forEach(initializeProductEditorial);
    document.addEventListener('shopify:section:load', (event) => initializeProductEditorial(event.target.querySelector('[data-marais-product-editorial]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marais-product-rail-modular"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initRail = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        root.classList.add('is-motion-ready');
        const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible'); observer.unobserve(entry.target);
        }), { threshold: .08, rootMargin: '0px 0px -8% 0px' });
        root.querySelectorAll('[data-mm-rail-reveal]').forEach((item) => observer.observe(item));
      }
      const track = root.querySelector('[data-mm-rail-track]');
      if (!track) return;
      const pages = root.querySelector('[data-mm-rail-pages]');
      let targets = [];
      const updatePage = () => {
        if (!pages || !targets.length) return;
        let current = 0;
        targets.forEach((target, index) => {
          if (Math.abs(track.scrollLeft - target) < Math.abs(track.scrollLeft - targets[current])) current = index;
        });
        Array.from(pages.children).forEach((button, index) => button.setAttribute('aria-current', index === current ? 'true' : 'false'));
      };
      const buildPages = () => {
        if (!pages || !track.firstElementChild) return;
        const items = Array.from(track.children);
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const step = items[0].getBoundingClientRect().width + gap;
        const visible = Math.max(1, Math.floor((track.clientWidth + gap) / step));
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        targets = [];
        for (let i = 0; i < items.length; i += visible) {
          const target = Math.min(max, i * step);
          if (!targets.length || target > targets[targets.length - 1] + 1) targets.push(target);
        }
        pages.replaceChildren();
        targets.forEach((target, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'mm-rail__page';
          button.textContent = String(index + 1).padStart(2, '0');
          button.setAttribute('aria-label', `${pages.getAttribute('aria-label')}: ${index + 1}`);
          button.addEventListener('click', () => track.scrollTo({ left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }));
          pages.append(button);
        });
        pages.hidden = targets.length < 2;
        updatePage();
      };
      track.addEventListener('scroll', updatePage, { passive: true });
      const resizeObserver = new ResizeObserver(buildPages);
      resizeObserver.observe(track);
      const unloadRail = (event) => {
        if (!event.target.contains(root)) return;
        resizeObserver.disconnect();
        document.removeEventListener('shopify:section:unload', unloadRail);
      };
      document.addEventListener('shopify:section:unload', unloadRail);
      buildPages();
      let startX = 0;
      let startScroll = 0;
      let moved = false;
      let activePointerId = null;

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;

        activePointerId = event.pointerId;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        moved = false;
      });

      track.addEventListener('pointermove', (event) => {
        if (activePointerId !== event.pointerId) return;

        const distance = event.clientX - startX;

        if (!moved && Math.abs(distance) > 6) {
          moved = true;
          track.classList.add('is-dragging');
          track.setPointerCapture(event.pointerId);
        }

        if (!moved) return;

        event.preventDefault();
        track.scrollLeft = startScroll - distance;
      });

      const stop = (event) => {
        if (activePointerId !== event.pointerId) return;

        track.classList.remove('is-dragging');

        if (track.hasPointerCapture(event.pointerId)) {
          track.releasePointerCapture(event.pointerId);
        }

        activePointerId = null;
      };

      track.addEventListener('pointerup', stop);
      track.addEventListener('pointercancel', (event) => {
        stop(event);
        moved = false;
      });

      track.addEventListener('click', (event) => {
        if (!moved) return;

        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }, true);
    };
    document.querySelectorAll('[data-mm-rail]').forEach(initRail);
    document.addEventListener('shopify:section:load', (event) => initRail(event.target.querySelector('[data-mm-rail]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marais-shop-look-modular"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initLook = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('is-motion-ready');
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (!entry.isIntersecting) return; entry.target.classList.add('is-visible'); observer.unobserve(entry.target);
      }), { threshold: .1, rootMargin: '0px 0px -8% 0px' });
      root.querySelectorAll('[data-mm-look-reveal]').forEach((item) => observer.observe(item));
      const travel = Number(root.dataset.imageTravel) || 0;
      root.style.setProperty('--mm-look-image-travel', `${travel}px`);
      const update = () => {
        if (window.innerWidth < 990) { root.style.setProperty('--mm-look-image-shift', '0px'); return; }
        const rect = root.getBoundingClientRect();
        const progress = Math.min(Math.max((window.innerHeight - rect.top) / (window.innerHeight + rect.height), 0), 1);
        root.style.setProperty('--mm-look-image-shift', `${Math.round(-travel * progress)}px`);
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    };
    document.querySelectorAll('[data-mm-look]').forEach(initLook);
    document.addEventListener('shopify:section:load', (event) => initLook(event.target.querySelector('[data-mm-look]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marais-universes-modular"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initReveal = (root) => {
      if (!root || root.dataset.revealReady === 'true') return;
      root.dataset.revealReady = 'true';
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('is-motion-ready');
      const items = root.querySelectorAll('[data-mm-reveal]');
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }), { threshold: .1, rootMargin: '0px 0px -8% 0px' });
      items.forEach((item) => observer.observe(item));
    };
    document.querySelectorAll('[data-mm-reveal-root]').forEach(initReveal);
    document.addEventListener('shopify:section:load', (event) => initReveal(event.target.querySelector('[data-mm-reveal-root]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marais-visitanos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initStore = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduced) {
        root.classList.add('is-motion-ready');
        const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (!entry.isIntersecting) return; entry.target.classList.add('is-visible'); observer.unobserve(entry.target);
        }), { threshold: .1, rootMargin: '0px 0px -8% 0px' });
        root.querySelectorAll('[data-store-reveal]').forEach((item) => observer.observe(item));
      }
      const update = () => {
        if (reduced || window.innerWidth < 990) { root.style.setProperty('--store-copy-shift', '0px'); root.style.setProperty('--store-image-shift', '0px'); return; }
        const rect = root.getBoundingClientRect();
        const progress = Math.min(Math.max((window.innerHeight - rect.top) / (window.innerHeight + rect.height), 0), 1);
        const travel = Number(root.dataset.parallax) || 0;
        root.style.setProperty('--store-copy-shift', `${Math.round(progress * travel)}px`);
        root.style.setProperty('--store-image-shift', `${Math.round(-progress * travel * .35)}px`);
      };
      window.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update, { passive: true }); update();
    };
    document.querySelectorAll('[data-marais-store]').forEach(initStore);
    document.addEventListener('shopify:section:load', (event) => initStore(event.target.querySelector('[data-marais-store]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
